export const LEVEL_OPTIONS = [
    { value: 'SITE', label: 'Site' },
    { value: 'BUSINESS_UNIT', label: 'Business Unit' },
    { value: 'GLOBAL', label: 'Global' },
];

export const PRIORITY_COLORS: Record<string, { border: string; bg: string; text: string; dot: string }> = {
    LOW:    { border: 'rgb(34,197,94)',  bg: 'rgb(240,253,244)', text: 'rgb(21,128,61)',  dot: 'rgb(34,197,94)'  },
    MEDIUM: { border: 'rgb(234,179,8)', bg: 'rgb(254,252,232)', text: 'rgb(161,98,7)',   dot: 'rgb(234,179,8)' },
    HIGH:   { border: 'rgb(239,68,68)', bg: 'rgb(254,242,242)', text: 'rgb(185,28,28)',  dot: 'rgb(239,68,68)'  },
};
